import RequireData from "hooks/RequireData";
import React from "react";
import { Button, ButtonGroup, ListGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import invitedTeamsSelector from "selectors/invitedTeams";
import invitedTeamsStatusSelector from "selectors/invitedTeamsStatus";
import styles from "./TeamInvite.module.scss";

const TeamsInvite: React.FC = () => {
    const dispatch = useDispatch();

    const [teams, status] = RequireData(
        invitedTeamsSelector,
        invitedTeamsStatusSelector,
        {
            type: "com.sage.actions.team.IFetchInvitedTeams",
        } as sage.actions.team.IFetchInvitedTeams
    );

    const onAcceptPressed = React.useCallback(
        (teamId: string) => () => {
            dispatch({
                type: "com.sage.actions.team.IAcceptTeamInvite",
                teamId,
            } as sage.actions.team.IAcceptTeamInvite);
        },
        [dispatch]
    );

    const onDeclinePressed = React.useCallback(
        (teamId: string) => () => {
            dispatch({
                type: "com.sage.actions.team.IRemoveSelfFromTeam",
                teamId: teamId,
            } as sage.actions.team.IRemoveSelfFromTeam);
        },
        [dispatch]
    );

    if (
        status === "loading" ||
        status === "error" ||
        !teams ||
        teams.length === 0
    ) {
        return null;
    }

    return (
        <div>
            <h4>Invites</h4>
            <ListGroup>
                {teams.map((t) => (
                    <ListGroup.Item key={t.id}>
                        <div className={styles.container}>
                            <span className={styles.title}>{t.name}</span>
                            <ButtonGroup>
                                <Button
                                    size="sm"
                                    variant="success"
                                    onClick={onAcceptPressed(t.id)}
                                >
                                    Accept
                                </Button>
                                <Button
                                    onClick={onDeclinePressed(t.id)}
                                    size="sm"
                                    variant="danger"
                                >
                                    Delete
                                </Button>
                            </ButtonGroup>
                        </div>
                    </ListGroup.Item>
                ))}
            </ListGroup>
        </div>
    );
};

export default TeamsInvite;
